"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackingUrls = exports.conditionalFields = exports.infieldLabel = exports.inputReactiveLabel = exports.forms = void 0;
const formhandler_1 = __importStar(require("../vendor/formhandler"));
const forms = () => {
    var _a, _b;
    const flashMessage = new formhandler_1.FlashMessage("#flash-message", 10000);
    const env = document.querySelector("body").getAttribute("data-env");
    const recaptcha_key = document
        .querySelector("meta[name='google_recaptcha_site_key']")
        .getAttribute("content");
    const forms = document.querySelectorAll(".ajax-form");
    for (let form of forms) {
        const alerts = JSON.parse(form.getAttribute('data-alerts'));
        const submitButton = form.querySelector('button[type="submit"]');
        new formhandler_1.default("#" + form.id, {
            recaptcha: new formhandler_1.GoogleV2(recaptcha_key),
            flashMessage: flashMessage,
            validate: {
                onChange: true,
                onSubmit: true,
            },
            localisation: {
                validationError: (_a = alerts['invalid']) !== null && _a !== void 0 ? _a : "There was a problem validating the form. Please try again.",
                error: "Sorry, there was an error with your submission. Please try again.",
                success: (_b = alerts['valid']) !== null && _b !== void 0 ? _b : "Thank you for your submission.",
            },
            onError: (form, res) => {
                submitButton.disabled = false;
            },
            onSuccess: (form, res) => {
                const formData = new FormData(form);
                const exclude = [
                    "g-recaptcha-response",
                    "token",
                    "_wpnonce",
                    "_email",
                ];
                let formDataObject = {};
                formData.forEach(function (value, key) {
                    if (!exclude.includes(key)) {
                        formDataObject[key] = value;
                    }
                });
                const labels = document.querySelectorAll("label[data-infield]");
                for (let label of labels) {
                    label.dataset.infield = "true";
                }
                if (env === "production") {
                    let firstName = formDataObject["first_name"];
                    let lastName = formDataObject["last_name"];
                    if (formDataObject['name']) {
                        firstName = formDataObject['name'].split(" ").length > 1 ? formDataObject['name'].split(" ")[0] : formDataObject['name'];
                        lastName = formDataObject['name'].split(" ").length > 1 ? formDataObject['name'].split(" ")[1] : '';
                    }
                    const newContact = {
                        "First name": firstName,
                        "Last name": lastName,
                        "Email": formDataObject['email'],
                        "Alternate contact number": formDataObject['telephone'],
                        "company": {
                            "Name": formDataObject['company_name'],
                            "Website": ''
                        }
                    };
                    const identifier = formDataObject['email'];
                    // @ts-ignore
                    fwcrm.identify(identifier, newContact);
                    submitButton.disabled = false;
                }
            },
        });
        form.addEventListener('submit', function (event) {
            submitButton.disabled = true;
        });
    }
};
exports.forms = forms;
const inputReactiveLabel = () => {
    const inputs = document.querySelectorAll(".js-infield");
    for (let input of inputs) {
        const updateState = () => {
            const label = document.querySelector(`label[for="${input.id}"]`);
            if (input.value) {
                label.dataset.infield = "false";
            }
            else {
                label.dataset.infield = "true";
            }
        };
        input.addEventListener("change", updateState);
        input.addEventListener("keyup", updateState);
        updateState();
    }
};
exports.inputReactiveLabel = inputReactiveLabel;
const infieldLabel = () => {
    const inputs = document.querySelectorAll('[data-infield="true"]');
    for (let input of inputs) {
        const updateState = () => {
            const label = document.querySelector(`label[for="${input.id}"]`);
            if (input.value.length > 0 || input === document.activeElement) {
                label.dataset.infield = "false";
            }
            else {
                label.dataset.infield = "true";
            }
        };
        input.addEventListener("focus", updateState);
        input.addEventListener("blur", updateState);
        input.addEventListener("change", updateState);
        input.addEventListener("keyup", updateState);
        updateState();
    }
};
exports.infieldLabel = infieldLabel;
const conditionalFields = () => {
    const conditionalFields = document.getElementsByClassName('conditional-field');
    Array.prototype.forEach.call(conditionalFields, (field, i) => {
        field.hidden = true;
    });
    document.addEventListener('change', function (event) {
        const target = event.target;
        if (!target.matches('.form-styled [data-toggle] select'))
            return;
        const conditionalField = document.getElementById(target.closest('[data-toggle]').getAttribute('data-toggle'));
        conditionalField.hidden = target.value !== 'other';
    });
};
exports.conditionalFields = conditionalFields;
const trackingUrls = () => {
    // create a new sessionStorage object
    const sessionStorage = window.sessionStorage;
    const sanitizeUrl = (url) => {
        url.hash = '';
        url.search = '';
        return url.href;
    };
    if (sessionStorage.getItem("landing_url") === null) {
        const landingUrl = new URL(window.location.href);
        sessionStorage.setItem("landing_url", sanitizeUrl(landingUrl));
    }
    const landingInputs = document.querySelectorAll('input[name="landing_url"]');
    const previousInputs = document.querySelectorAll('input[name="previous_url"]');
    if (landingInputs.length === 0)
        return;
    landingInputs.forEach(input => {
        input.value = sessionStorage.getItem("landing_url");
    });
    if (previousInputs.length === 0)
        return;
    previousInputs.forEach(input => {
        if (!document.referrer)
            return;
        const previousUrl = new URL(document.referrer);
        input.value = sanitizeUrl(previousUrl);
    });
};
exports.trackingUrls = trackingUrls;
